import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { setUserTheme } from 'src/app/reducers/user/user.actions';
import { selectUserTheme } from 'src/app/reducers/user/user.selector';

import { SettingsModalComponent } from '../../nav-header/components/settings-modal/settings-modal.component';
import {
  SETTINGS_GROUPS,
  SettingsModalComponentData,
} from '../../nav-header/components/settings-modal/settings-modal.model';
import { API } from '../constants/api.constants';
import { UserTheme } from '../models/user.model';
import { ErrorHandlingHttpClient } from './error-handling-http-client.service';
import { ModalService } from './modal-service.service';

@Injectable({
  providedIn: 'root'
})
export class UserSettingsService {
  userTheme$ = this.store.select(selectUserTheme);

  constructor(private store: Store, private errorHandlingHttpClient: ErrorHandlingHttpClient, private modalService: ModalService) {}

  public static getLocalUserTheme() {
    try {
      return window.localStorage.getItem('fusion-produceit-user-theme') || UserTheme.LIGHT;
    } catch (e) {
      return UserTheme.LIGHT;
    }
  }

  public static setLocalUserTheme(newTheme: string): void {
    window.localStorage.setItem('fusion-produceit-user-theme', newTheme);
  }

  public initiate() {
    this.store.dispatch(setUserTheme({theme: UserSettingsService.getLocalUserTheme()}));
  }

  public setStoredUserTheme(newTheme: string) {
    UserSettingsService.setLocalUserTheme(newTheme);
    this.store.dispatch(setUserTheme({theme: newTheme}));
  }

  public updateUserTheme(theme) {
    return this.errorHandlingHttpClient
      .put(API.darkModeChange, {
        value: theme
      })
      .subscribe(() => {
        this.store.dispatch(setUserTheme({theme}));
      });
  }

  public getEmailSignature$(): Observable<{
    value: string;
  }> {
    return this.errorHandlingHttpClient.get(API.userEmailSignature());
  }

  public openModal(
    data = {
      section: SETTINGS_GROUPS.EMAIL_SIGNATURE
    }
  ) {
    return this.modalService.openModal<SettingsModalComponent, SettingsModalComponentData>(SettingsModalComponent, data, undefined, true, true, {
      width: `640px`
    });
  }
}
